import LzCModuleChildBase, { LzIModuleChildBase } from './ModuleChildBase';
import LzCEntity, { LzIEntity } from './Entity';
import LzCPage, { LzIPage } from './Page';
import LzCReport, { LzIReport } from './Report';
import { LzTOpenObject } from '../typings';
import { LzTModuleChildCollection } from './types';

export interface LzIModule extends LzIModuleChildBase {
    /**
     * Child modules, entities or pages in this module (optional).
     */
    children?: LzTModuleChildCollection;
}

class LzCModule extends LzCModuleChildBase implements LzIModule {
    children: LzTModuleChildCollection;

    constructor(model?: LzIModule) {
        super(model);

        this.variation = 'Module';

        this.children = [];
        if (model?.children) {
            // Loop on each item in children
            for (const dex in model.children) {
                const item = model.children[dex];

                const commonOverriden: LzTOpenObject = {
                    baseRoute: this.fullRoute,
                    baseRightsPath: this.rightsPath,
                };
                if (this.rightsKey === '') {
                    commonOverriden.rightsKey = '';
                }

                // If it is Module
                if ('Module' === item.variation) {
                    this.children[dex] = new LzCModule(Object.assign({}, model.children[dex], commonOverriden) as LzIModule);
                }

                // Else-if it is Entity
                else if ('Entity' === item.variation) {
                    this.children[dex] = new LzCEntity(Object.assign({}, model.children[dex], commonOverriden) as LzIEntity);
                }

                // Else-if it is Report
                else if ('Report' === item.variation) {
                    this.children[dex] = new LzCReport(Object.assign({}, model.children[dex], commonOverriden) as LzIReport);
                }

                // Else if is Page
                else {
                    this.children[dex] = new LzCPage(Object.assign({}, model.children[dex], commonOverriden) as LzIPage);
                }
            }
        }
    }

    /**
     * Get a child entity based on the given ident.
     *
     * @param ident The string ident value. TODO: For now it works on a single level, we can make it work on multiple levels by using an ident like: `moduleid.entityid`
     *
     * @returns Returns either null or the found entity.
     */
    getChildEntity(ident: string): LzCEntity | null {
        // Find a direct child with the given ident
        const found = this.children.filter((child) => child.ident === ident);

        // If found then return the first one
        if (found && found.length > 0 && found[0] instanceof LzCEntity) {
            return found[0];
        }

        // If not found then return null
        return null;
    }
}

export default LzCModule;
